export default __webpack_public_path__ + "static/media/green-check-circle.11e08bbf.svg";